import { pagination } from "../../components/Pagination/Pagination";

import searchResultTemplate from "./SearchResult.hbs";

import "./search-page.scss";

(function () {
    if (document.querySelectorAll(".js-search").length > 0) {
        let controller = new AbortController();

        const searchPage = {
            store: {
                charArray: [16, 17, 18, 20, 27, 37, 38, 39, 40],
                isLoading: false,
                data: null,
                documentBody: document.getElementsByTagName("body")[0],
            },
            init: function () {
                pagination.init();
                searchPage.toggleSearchPanel();
                searchPage.onUserSearch();
            },
            toggleSearchPanel: () => {
                const openSearchButtons = document.getElementsByClassName("js-search");
                const closeSearchButtons = document.getElementsByClassName("js-search-close");
                const documentBody = document.getElementsByTagName("body")[0];

                Array.from(openSearchButtons).forEach(btn => {
                    btn.addEventListener("click", () => {
                        const container = btn.closest(".js-search-wrapper");
                        const searchPanel = container.getElementsByClassName("js-search-panel")[0];
                        const searchField = container.getElementsByClassName("js-search-input")[0];

                        documentBody.classList.add("search--expanded");

                        searchPanel.classList.add("search__panel--visible");

                        searchField.focus();
                    });
                });

                Array.from(closeSearchButtons).forEach(btn => {
                    btn.addEventListener("click", () => {
                        const container = btn.closest(".js-search-wrapper");
                        const searchPanel = container.getElementsByClassName("js-search-panel")[0];
                        const searchField = container.getElementsByClassName("js-search-input")[0];
                        const resultsList = container.getElementsByClassName("js-results-list")[0];
                        
                        searchPanel.classList.remove("search__panel--visible");

                        documentBody.classList.remove("search--expanded");
                        searchPage.store.documentBody.classList.remove(
                            "search__results--show"
                        );

                        resultsList.innerHTML = "";
                        searchField.value = "";
                    });
                });
            },
            onUserSearch: () => {
                const searchField = document.getElementsByClassName("js-search-input");
                const searchPageUrl = document.getElementById("search-page-url");
                Array.from(searchField).forEach(input => {
                    input.addEventListener("keyup", (e) => {
                        if (e.keyCode === 13) {
                            if (searchPageUrl !== "") {
                                window.location.href =
                                    searchPageUrl.value + "?q=" + input.value;
                            }
                        } else {
                            searchPage.store.documentBody.classList.remove(
                                "search__results--show"
                            );

                            const container = input.closest(".js-search-wrapper");
    
                            if (!searchPage.store.charArray.includes(e.keyCode)) {
                                if (input.value.length > 2) {
                                    searchPage.store.documentBody.classList.add(
                                        "search--searching"
                                    );
                                    doSearch(input.value, container);
                                }
                            }
                        }
                    });
                });

                let delayTimer;

                function doSearch(text, container) {
                    clearTimeout(delayTimer);

                    delayTimer = setTimeout(function () {
                        searchPage.performSearch(text, container);
                    }, 1000);
                }
            },
            performSearch: (searchTerm, container) => {
                searchPage.store.isLoading = true;
                searchPage.renderView(null, container);
                let signal = controller.signal;

                if (searchPage.store.isLoading) {
                    controller.abort("Starting new search request.");
                    controller = new AbortController();
                    signal = controller.signal;
                }

                searchPage.store.isLoading = true;
                searchPage.renderView(null, container);

                fetch(`/api/search/autocomplete?q=${searchTerm}&lang=${document.documentElement.lang}`, { signal })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then(data => {
                        searchPage.store.data = data;
                    })
                    .catch(error => {
                        console.error(error);
                        searchPage.store.documentBody.classList.remove("search--searching");
                    })
                    .finally(() => {
                        searchPage.store.isLoading = false;
                        searchPage.renderView(searchPage.store.data, container);
                    });
            },
            renderView: (data, container) => {
                const target = container.getElementsByClassName("js-results-list")[0];

                if (target !== null) {
                    target.innerHTML = searchResultTemplate(data);

                    // Update screen reader accessible result count
                    const resultCountSpan = document.getElementById("search-results-count");
                    if (resultCountSpan) {
                        const count = Array.isArray(data) ? data.length : 0;
                        resultCountSpan.textContent = `${count} match${count !== 1 ? "es" : ""} found`;
                    }

                    // Add Space key handler to each result item
                    const items = target.querySelectorAll(".search-result-item");
                    items.forEach(item => {
                        item.addEventListener("keydown", function (event) {
                            if (event.code === "Space" || event.key === " ") {
                                event.preventDefault();
                                const url = item.getAttribute("data-url");
                                if (url) {
                                    window.location.href = url;
                                }
                            }
                        });
                    });

                    setTimeout(function () {
                        searchPage.store.documentBody.classList.add(
                            "search__results--show"
                        );
                        searchPage.store.documentBody.classList.remove(
                            "search--searching"
                        );
                    }, 100);
                }
            }
        };

        searchPage.init();
    }
})();
